import { render } from "./evaluacionComedor.vue?vue&type=template&id=1e617bc0&scoped=true"
import script from "./evaluacionComedor.vue?vue&type=script&lang=js"
export * from "./evaluacionComedor.vue?vue&type=script&lang=js"

import "./evaluacionComedor.vue?vue&type=style&index=0&id=1e617bc0&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e617bc0"]])

export default __exports__